import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import localData from "../../localData";
import { Button } from "../../components";
import { useGlobalContext } from "../../context";
import audioSrc from "../../assets/audio.mp3";
//
export default function Navbar() {
    const audioRef = useRef();

    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        if (isPlaying) {
            console.log("play");
            console.log(audioRef.current);

            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
    }, [isPlaying]);

    const location = useLocation();
    // CONFIG WITH MODAL
    const { isNavbarCollapsing, setIsNavbarCollapsing, isNavbarShown, setIsNavbarShown } = useGlobalContext();
    //
    const navs = [
        { name: "home", pathname: "#home" },
        { name: "about", pathname: "#about" },
        { name: "resume", pathname: "#experience" },
        { name: "services", pathname: "#services" },
    ];

    const { sound, closer, toggler } = localData.svgs;
    const { signature } = localData.user;

    // CONFIG WITHOUT MODAL
    // const [isNavbarCollapsing, setIsNavbarCollapsing] = useState(false);
    // const [isNavbarShown, setIsNavbarShown] = useState(false);
    //

    // const [isDropdownShown, setIsDropdownShown] = useState(false);
    // const [topRect, setTopRect] = useState(false);

    const navbar = useRef();
    const navbarNav = useRef();

    // useEffect(() => {
    //     document.addEventListener("scroll", () => setTopRect(window.scrollY)); //window.scrollY > 300
    // }, []);

    useEffect(() => {
        const adaptLayouts = (isModified) => {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + "px";
            const navbar = document.querySelector(".navbar");

            if (isModified) {
                document.body.style.paddingRight = scrollbarWidth;
                document.body.style.overflow = "hidden";
                // navbar.style.borderRight = `${scrollbarWidth} solid transparent`;
                document.body.setAttribute("data-dismiss", "modified-layout");
                return;
            }

            document.body.style.paddingRight = "";
            document.body.style.overflow = "";
            navbar.style.borderRight = "";
            document.body.removeAttribute("data-dismiss");
        };
        adaptLayouts(isNavbarShown);
    }, [isNavbarShown]);

    useEffect(() => {
        isNavbarShown ? fadeLinks() : unfadeLinks();
        if (isNavbarCollapsing) setIsNavbarShown(!isNavbarShown);
    }, [isNavbarCollapsing]);

    const fadeLinks = () => {
        navbarNav.current.querySelectorAll(".nav-link").forEach((link, index) => {
            link.style.animation = `navLinkFade 0.7s ease forwards ${index / 7}s `;
        });
    };

    const unfadeLinks = () => {
        navbarNav.current.querySelectorAll(".nav-link").forEach((link) => (link.style.animation = ""));
    };

    return (
        <>
            <nav
                className={`navbar navbar-expand-lg navbar-dark`}
                style={isNavbarShown ? { pointerEvents: "none" } : {}}
                ref={navbar}
            >
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">
                        <img src={signature} alt="signature" />
                    </Link>
                    <button
                        className={`navbar-toggler  ${isNavbarShown ? "collapsed" : ""}`}
                        type="button"
                        onClick={() => setIsNavbarCollapsing(true)}
                    >
                        <span className="navbar-toggler-icon">{toggler}</span>
                    </button>
                    <div
                        className={`navbar-collapse ${isNavbarCollapsing ? "collapsing" : ""} collapse ${
                            isNavbarShown ? "show" : ""
                        }`}
                        id="navbarSupportedContent"
                        onTransitionEnd={() => setIsNavbarCollapsing(false)}
                    >
                        <span className="closer" onClick={() => setIsNavbarCollapsing(true)}>
                            {closer}
                        </span>
                        <ul ref={navbarNav} className="navbar-nav">
                            {navs.map((item, index) => {
                                const { name, pathname } = item;
                                return (
                                    <li className="nav-item" key={index}>
                                        <a
                                            className={`nav-link ${pathname === location.pathname ? "active" : ""}`}
                                            aria-current="page"
                                            // to={pathname}
                                            href={pathname}
                                            onClick={() => setIsNavbarShown(false)}
                                        >
                                            .{name}()
                                        </a>
                                    </li>
                                );
                            })}
                            {/* <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    onClick={() => setIsDropdownShown(!isDropdownShown)}
                                    onBlur={() => setIsDropdownShown(false)}
                                >
                                    Dropdown
                                </a>
                                <ul className={`dropdown-menu ${isDropdownShown ? "show" : ""}`}>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            Action
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            Another action
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            Something else here
                                        </a>
                                    </li>
                                </ul>
                            </li> */}
                        </ul>
                    </div>
                    <a className="sound" href="#/">
                        <audio loop={true} autoPlay={true} ref={audioRef} src={audioSrc}></audio>
                        <span className={`sound-icon ${isPlaying ? 'sound-icon-success':''}`}>{sound}</span>
                        <span className="sound-text">sound</span>

                        <span
                            className={`sound-switcher ${isPlaying ? "sound-switcher-success" : ""}`}
                            onClick={() => setIsPlaying(!isPlaying)}
                        >
                            {isPlaying ? "on" : "off"}
                        </span>
                    </a>
                </div>
            </nav>
            <div
                className={`navbar-backdrop ${isNavbarShown ? "show" : ""}`}
                onClick={() => setIsNavbarCollapsing(true)}
            ></div>
        </>
    );
}
